import React from 'react';
import Section from '~/App/shared/components/Layout/Section';
import NotificationUnsubscribeForm from './components/Form';
import NotificationUnsubscribeSubmit from './components/Submit';
import { QueryParams } from '../types';
import { useTranslation } from '~/Locale';
import styled from 'styled-components';
import { Subtitle, Message } from '@kvdbil/components';

const Container = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
`;

const Wrapper = styled.div`
  padding: 2rem 0;
  text-align: center;
  max-width: 360px;
  margin: auto;
`;

const StyledSubtitle = styled(Subtitle)`
  font-weight: ${({ theme }) => theme.typography.fontAlternativeBoldWeight};
  margin-bottom: 1.5rem;
`;

interface Props {
  queryParams: QueryParams;
}

const NotificationUnsubscribe = ({ queryParams }: Props) => {
  const { t } = useTranslation();
  const {
    template = '',
    member_id = '',
    hash = '',
    newsletterId = ''
  } = queryParams;

  const unsubscribeParams = newsletterId
    ? {
        hash,
        newsletterId
      }
    : {
        hash,
        template,
        memberId: member_id
      };
  return (
    <Container>
      <div>
        <Section
          backgroundColor="gray"
          maxWidth={32}
          contentBackgroundColor="light"
        >
          <Wrapper>
            <NotificationUnsubscribeSubmit params={unsubscribeParams}>
              {submit => {
                if (submit.isCompleted && !submit.errors) {
                  return (
                    <>
                      <StyledSubtitle as="h3">
                        {t('Removed from your inbox')}
                      </StyledSubtitle>
                      <Message withIcon type="success">
                        {t(
                          'You have now been unsubscribed from this type of emails.'
                        )}
                      </Message>
                    </>
                  );
                }

                return (
                  <>
                    <StyledSubtitle as="h3">
                      {t('Would you like to unsubscribe from notification?')}
                    </StyledSubtitle>
                    <NotificationUnsubscribeForm submit={submit} />
                  </>
                );
              }}
            </NotificationUnsubscribeSubmit>
          </Wrapper>
        </Section>
      </div>
    </Container>
  );
};

export default NotificationUnsubscribe;
